<template>
  <!-- <v-layout row wrap>
    <v-flex>

      <v-slide-y-transition mode="out-in"> -->
        <v-container fluid class="pa-3">

          <v-layout row wrap>
            <v-flex>
              <v-card>
                <v-toolbar dense prominent>
                  <v-icon>list</v-icon>
                  <v-toolbar-title>Log Event</v-toolbar-title>
                  <v-spacer></v-spacer>

                  <v-toolbar-items>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn class="primary" small fab @click="back_url()" v-on="on">
                          <v-icon>arrow_back</v-icon>
                        </v-btn>
                      </template>
                      <span>Back</span>
                    </v-tooltip>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text class="pa-0">
                  <!-- <v-container fluid> -->
                    <v-layout row wrap>
                      <v-flex xs12>

                        <v-expansion-panel>
                          <v-expansion-panel-content class="accent">
                            <template v-slot:header>
                              <div style="font-size: medium;">Filter Panel</div>         
                            </template>

                            <v-container fluid class="pt-0">
                              <v-layout row wrap>
                                <v-flex class="text-xs-right">
                                  <v-btn color="orange" small fab @click="selected_filter.push({field:'', value:'',type:''})"><v-icon color="white">add</v-icon></v-btn>
                                  <v-btn color="green" @click="refreshData()">GENERATE NOW</v-btn>
                                  <v-btn color="cyan lighten-1" @click="selected_filter=[], refreshData()">RESET FILTER</v-btn>
                                </v-flex>
                              </v-layout>

                              <v-layout row wrap>
                                <v-flex>
                                  <v-card>
                                    <v-card-text v-if="selected_filter.length > 0">
                                      <!-- <v-container> -->
                                        <v-layout row wrap
                                          v-for="(item,i) in selected_filter"
                                          :key="i"
                                        >                                
                                          <v-flex xs12 md5>
                                            <v-select
                                              v-model="selected_filter[i].field"
                                              :items="get_filterable_columns"
                                              @change="d_onchange(selected_filter[i])"
                                              clearable
                                              item-text="text"
                                              item-value="value"
                                              label="select field"
                                            ></v-select>
                                          </v-flex>
                                          <v-flex xs12 md1 class="text-md-center">
                                            contains
                                          </v-flex>
                                          <v-flex xs12 md5>
                                            <v-text-field
                                              v-model="selected_filter[i].value"
                                              label="your text"
                                            ></v-text-field>
                                          </v-flex>
                                          <v-flex xs12 md1>
                                            <v-layout justify-space-around class="mb-2">
                                              <span class="group pa-2">
                                                <v-btn color="red" small fab @click="selected_filter.splice(i,1)" :disabled="false"><v-icon color="white">clear</v-icon></v-btn>
                                                
                                              </span>
                                            </v-layout>
                                          </v-flex>

                                        </v-layout>
                                      <!-- </v-container> -->
                                    </v-card-text>
                                  </v-card>
                                </v-flex>
                              </v-layout>

                            </v-container>
                          </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-data-table
                          :headers="table.headers"
                          :items="table.items"
                          :loading="table.loading"
                          must-sort
                          :pagination.sync="table.pagination"
                          :rows-per-page-items="table.rows_per_page_items"
                          :total-items="table.total_items"
                          class="elevation-1"
                        >
                          <v-progress-linear color="blue" indeterminate>
                            <template v-slot:progress>
                            </template>
                          </v-progress-linear>
                          <template v-slot:items="props">
                            <td class="pa-1 pl-3">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    v-on="on"
                                    flat
                                    icon
                                    small
                                    :disabled="!is_actionBtn"
                                    color="primary"
                                    @click="btn_onClick(props.item._id)"                                
                                  ><v-icon>mail</v-icon></v-btn>
                                </template>
                                <span>Resend</span>
                              </v-tooltip>
                            </td>
                            <td class="pa-1">{{ props.item.created_by }}</td>
                            <td class="pa-1">
                              {{
                              epoch2localedatetime(props.item.epoch)
                              }}
                            </td>
                            <td class="pa-1">{{ props.item._id }}</td>
                            <td class="pa-1">{{ props.item.source }}</td>
                            <td class="pa-1">{{ props.item.event }}</td>
                            <td class="pa-1">
                              <pre v-html="populate_obj(props.item.data)"></pre>
                            </td>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  <!-- </v-container> -->
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

        </v-container>
      <!-- </v-slide-y-transition>

    </v-flex>
  </v-layout> -->

</template>

<script>
// import axios from "axios";
import auth from "../../functions/auth";
import common from "../../functions/general";
// import comm from "../../functions/communication.api";
import query_builder from "../../functions/query.builder";

export default {
  name: "req_log",
  // components: {
  //   PageLayout: PageLayout,
  // },
  data() {
    return {
      username: "",
      // reqStatus_option: "",
      // reqRec: {},
      showMenu: false,
      filters_setting: {
        filter_row: 0,
      },
      selected_filter: [],
      rules: {
				required: (value) => !!value || "This field required.",
				greater_than_zero: (value) => value > 0 || "Value must greater than 0.",
			},
      table: {
        rows_per_page_items: [2, 10, 40, 70, 100],
        headers: [
          {
            text: "",
            class: "pa-1 pl-3",
            value: "",
            filterable: false,            
            sortable: false,
            data_type: "String"
          },
          {
            text: "Created By",
            // align: "left",
            class: "pa-1",
            value: "created_by",
            filterable: true,            
            sortable: true,
            data_type: "String"
          },
          {
            text: "Created DateTime",
            // align: "left",
            class: "pa-1",
            value: "epoch",
            filterable: false,            
            sortable: true,
            data_type: "Date"
          },
          {
            text: "#ID",
            class: "pa-1",
            value: "_id",
            filterable: true,
            sortable: true,
            data_type: "String"
          },
          {
            text: "Source",
            class: "pa-1",
            value: "source",
            filterable: true,
            sortable: true,
            data_type: "String"
          },
          {
            text: "Event",
            class: "pa-1",
            value: "event",
            filterable: true,
            sortable: false,
            data_type: "String"
          },
          {
            text: "Content",
            class: "pa-1",
            value: "data",
            filterable: true,
            sortable: true,
            data_type: "String"
          }
        ],
				items: [],
				total_items:0,
				loading: false,
				pagination: {
					descending: true,
					page: 1,
					rowsPerPage: 10,
					sortBy: "_id",
					totalItems: 100
				},
      },
      status_option: [],
      selected: { // to update
				_id: "",
        source: "",
        event: ""
      },
      // back_url: "",
      is_actionBtn: false,
      q_str: {
        "Lso": "",
        "Lev": ""
      }
    };
  },
  computed: {
    get_filterable_columns() {
      var return_value = this.table.headers.filter(
        rec => rec.filterable == true
      );
      return return_value;
    },
    // disabled_btn() {
    //   var value = false;

    //   try {
    //     if (this.reqRec.g_status_id == this.reqStatus_option[2]._id) {
    //       value = true;
    //     }  
    //   } catch (error) {}
      
    //   return value;
    // }
  },
  watch: {
    "table.pagination": {
      handler: function() {
        this.refreshData();
      },
      deep: true
    },
  },
  async mounted() {
    common.App.set_page_title("mySuite: Req Email Log");
    
    this.username = auth.getUsername();
    
    this.q_str.Lso = common.App.getQueryString("Lso");
    this.q_str.Lev = common.App.getQueryString("Lev");

    if (this.q_str.Lev == "email") {
      this.is_actionBtn = true;
    }
  },
  created (){
    auth.hideHeader(false);
  },
  methods: {
    epoch2localedatetime: common.App.epoch2LocaleDatetime,
    populate_obj(obj) {
      var temp = JSON.stringify(obj,null, 4);
      return temp.replaceAll("\\n","");
    },
    d_onchange(ind){
      var temp = this.table.headers.find(el => el.value == ind.field);
      ind.type = temp.data_type;
    },
    async refreshData() {
			this.table.loading = true;
			var qb = new query_builder.QueryBuilder();

			qb.Table = "event_log";
			qb.Limit = this.table.pagination.rowsPerPage;
			qb.Offset = this.table.pagination.page;

			// must check sortBy before push in order array
			if (this.table.pagination.sortBy) {
				qb.Order = [
					{
						name: this.table.pagination.sortBy,
						descending: this.table.pagination.descending,
					}
				];
			}

      let rule = new query_builder.Rule();
      
      rule
        .field("source")
        .operator(query_builder.A_STR_OPERATOR.EQUAL)
        .value(this.q_str.Lso);
      qb.Where.rules.push(rule);
      
      if (this.q_str.Lev) {
        rule = new query_builder.Rule();
        rule
          .field("event")
          .operator(query_builder.A_STR_OPERATOR.I_CONTAINS)
          .value(this.q_str.Lev);
        qb.Where.rules.push(rule);        
      }

      let filter_len = this.selected_filter.length;

      if (filter_len>0) {
        for (let i =0; i<filter_len; i++) {

          switch(this.selected_filter[i].type) {
            case "String":
              rule = new query_builder.Rule();
              rule
                .field(this.selected_filter[i].field)
                .operator(query_builder.A_STR_OPERATOR.I_CONTAINS)
                .value(this.selected_filter[i].value);
              break;
  
            case "Number":
              break;
  
            case "Date":
              break; 
          }
          qb.Where.rules.push(rule);
        }
      }
      
			var res = await common.wBackEndComm.PostData("process_arango_qb/", qb);
			res = res.data;
			if (res.Status == 1) {
				this.table.items = res.Body[0].records;
				this.table.total_items = res.Body[0].total_records;
			} else {
				common.wMsgBox.Error(res.Description);
			}

			this.table.loading = false;
    },
    async btn_onClick(eventlogID) {
      common.App.loader.show(this);
      this.table.loading = true;

      var res = await common.wBackEndComm.PostData("mycareer/requisition_email_resend/", eventlogID);
			res = res.data;
			if (res.Status == 1) {
				common.wMsgBox.Success(res.Description);
        this.refreshData();
			} else {
				common.wMsgBox.Error(res.Description);
			}      
      
      this.table.loading = false;
      common.App.loader.hide(this);
    },
    back_url() {
      window.history.back();
    }
  }
};
</script>

<style>

</style>
